"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonMultiCarousel = require("@mmc/common-multi-carousel");
var _react = _interopRequireDefault(require("react"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _mmcVehicleCodeUtility = _interopRequireWildcard(require("@mmc-tools/mmc-vehicle-code-utility"));
var _homepageCarSelector = _interopRequireDefault(require("../styles/homepage-car-selector.css"));
var _carSelectorTitle = _interopRequireDefault(require("./car-selector-title"));
var _mobileCarousel = _interopRequireDefault(require("./mobile-carousel"));
var _homepageCarSelector2 = _interopRequireWildcard(require("./homepage-car-selector.props/homepage-car-selector.propTypes"));
var _homepageCarSelectorEntry = _interopRequireDefault(require("./homepage-car-selector-entry"));
var _div;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _VehicleCodeUtilityCl = new _mmcVehicleCodeUtility["default"](_mmcVehicleCodeUtility.VEHICLES_MAP),
  getVehicleByGuid = _VehicleCodeUtilityCl.getVehicleByGuid;
var _DataUtils = new _mmcDataUtilities["default"](),
  isEmptyArray = _DataUtils.isEmptyArray;

/**
 * ## HomepageCarSelector - component
 *
 * This is the card portion of the two-part car selector. It will be fed into the carousel component.
 */
/* Check user agent string for Android or iOS client */
var checkForMobileAgent = function checkForMobileAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};
var HomepageCarSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HomepageCarSelector, _React$Component);
  HomepageCarSelector.resourceType = function resourceType() {
    return 'CarSelector_1_0_0';
  };
  function HomepageCarSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var debounceDelay = 100;
    var debounceOptions = {
      leading: true,
      trailing: true
    };
    _this.state = {
      isDuplicate: false,
      hasDuplicates: false,
      isMobile: false,
      selectedMobileIndex: null
    };
    _this.renderCards = _this.renderCards.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChangeEvent = _this.handleChangeEvent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDuplicates = _this.setDuplicates.bind((0, _assertThisInitialized2["default"])(_this));
    _this.compareModelCodes = _this.compareModelCodes.bind((0, _assertThisInitialized2["default"])(_this));
    _this.selectCarAuto = _this.selectCarAuto.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWindowResize = (0, _debounce2["default"])(_this.handleWindowResize.bind((0, _assertThisInitialized2["default"])(_this)), debounceDelay, debounceOptions);
    return _this;
  }
  var _proto = HomepageCarSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleWindowResize);

      // running handleWindowResize here so that we can determine on render if it's mobile
      this.handleWindowResize();
      if (window.location.search.includes('?')) {
        this.selectCarAuto(window.location.href);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  };
  _proto.handleWindowResize = function handleWindowResize() {
    var width = 0;
    var isMobileAgent = false;
    if (typeof window !== 'undefined') {
      width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
      isMobileAgent = checkForMobileAgent();
    }
    if (width < 768 && isMobileAgent) {
      this.setState(function () {
        return {
          isMobile: true
        };
      });
    } else {
      this.setState(function () {
        return {
          isMobile: false
        };
      });
    }
  };
  _proto.handleChangeEvent = function handleChangeEvent(e) {
    var isDuplicate = this.state.isDuplicate;
    var _this$props = this.props,
      updateErrors = _this$props.updateErrors,
      errorMessages = _this$props.errorMessages,
      handleChangeEvent = _this$props.handleChangeEvent,
      handleFieldBlur = _this$props.handleFieldBlur,
      actions = _this$props.actions,
      _this$props$position = _this$props.position,
      position = _this$props$position === void 0 ? [0] : _this$props$position;

    // Clear Errors upon any selection
    if (updateErrors !== undefined && errorMessages !== undefined) {
      if (errorMessages.find(function (message) {
        return message !== '';
      }) !== undefined) {
        updateErrors([0], ['', '']);
      }
    }
    var el = e.target;
    var radioValue = el.value.toString();
    var selectedVehicle = {
      code: el.getAttribute('data-code'),
      year: el.getAttribute('data-year')
    };
    if (radioValue.includes('-DUPLICATE')) {
      radioValue = radioValue.replace('-DUPLICATE', '');
      if (isDuplicate !== true) {
        this.setState({
          isDuplicate: true
        });
      }
    } else if (isDuplicate !== false) {
      this.setState({
        isDuplicate: false
      });
    }

    // Cleanse value if mobile carousel
    var mobileIndexMatch = radioValue.match(/--\d+$/);
    if (mobileIndexMatch) {
      var selectedMobileIndex = mobileIndexMatch[0].replace('--', '');
      radioValue = radioValue.replace(/--\d+$/, '');
      this.setState({
        selectedMobileIndex: selectedMobileIndex
      });
    }
    if (handleChangeEvent) {
      handleChangeEvent(position, [radioValue]);
    }
    if (actions) {
      actions.selectVehicle(selectedVehicle);
    }
    if (handleFieldBlur) {
      handleFieldBlur([radioValue], position, ['', '']);
    }
  };
  _proto.getVehicleObjectFromString = function getVehicleObjectFromString(vehicleString) {
    var selectedVehicle = {
      code: vehicleString
    };
    if (typeof vehicleString === 'string') {
      vehicleString.split('_').forEach(function (data, i) {
        selectedVehicle["" + (i === 0 ? 'code' : 'year')] = data;
      });
    }
    selectedVehicle.code = this.shouldDecode(_mmcVehicleCodeUtility.VEHICLES_MAP, selectedVehicle.code) ? getVehicleByGuid(selectedVehicle.code) : selectedVehicle.code;
    selectedVehicle.string = "" + selectedVehicle.code + (selectedVehicle.year ? "_" + selectedVehicle.year : '');
    return selectedVehicle;
  };
  _proto.getVehicleString = function getVehicleString() {
    var _this2 = this;
    var _this$props2 = this.props,
      selectedValue = _this$props2.selectedValue,
      actions = _this$props2.actions,
      handleChangeEvent = _this$props2.handleChangeEvent,
      productTile = _this$props2.productTile,
      _this$props2$position = _this$props2.position,
      position = _this$props2$position === void 0 ? [0] : _this$props2$position;
    var vehicleString = selectedValue;
    if ((selectedValue === undefined || selectedValue === null || selectedValue === '') && !actions) {
      if (typeof document !== 'undefined' && document.cookie.includes('carSelected')) {
        var documentCookies = document.cookie.split('; ');
        for (var i = 0; i < documentCookies.length; i += 1) {
          var oneCookie = documentCookies[i];
          if (oneCookie.includes('carSelected')) {
            var cookiePair = oneCookie.split('=');
            vehicleString = cookiePair[1];
            if (handleChangeEvent && productTile) {
              (function () {
                var cookieVehcileData = typeof vehicleString === 'string' ? vehicleString.split('_') : [vehicleString];
                var vehicleCode = getVehicleByGuid(cookieVehcileData[0]);
                var selectedMobileIndex = productTile.findIndex(function (vehicle) {
                  return vehicle.code === vehicleCode && (cookieVehcileData[1] === undefined || Number(cookieVehcileData[1]) === Number(vehicle.year));
                });
                _this2.setState({
                  selectedMobileIndex: selectedMobileIndex
                });
                handleChangeEvent(position, ["" + vehicleCode + (cookieVehcileData[1] ? "_" + cookieVehcileData[1] : '')]);
              })();
            }
          }
        }
      }
    }
    return vehicleString;
  };
  _proto.setDuplicates = function setDuplicates() {
    var hasDuplicates = this.state.hasDuplicates;
    if (hasDuplicates !== true) {
      this.setState({
        hasDuplicates: true
      });
    }
  };
  _proto.shouldDecode = function shouldDecode(map, value) {
    return map.filter(function (el) {
      return el.guid === value;
    }).length > 0;
  };
  _proto.compareModelCodes = function compareModelCodes(productName, carmodelUrl) {
    return productName.replace(/\s/g, '').toLowerCase() === carmodelUrl.toLowerCase();
  };
  _proto.selectCarAuto = function selectCarAuto(url) {
    var _this3 = this;
    var _this$props3 = this.props,
      data = _this$props3.data,
      handleChangeEvent = _this$props3.handleChangeEvent,
      handleFieldBlur = _this$props3.handleFieldBlur,
      actions = _this$props3.actions,
      _this$props3$position = _this$props3.position,
      position = _this$props3$position === void 0 ? [0] : _this$props3$position;
    var urlVariables = new URL(url);
    var carModel = urlVariables.searchParams.get('model');
    var carModelNextyear = carModel;
    if (!carModel) return;
    var products = data.productTile;
    var modelCodeIncludes = products.some(function (product) {
      var productName = product.name;
      if (productName.startsWith(carModel.slice(0, 4))) {
        return _this3.compareModelCodes(productName, carModel);
      }
      return _this3.compareModelCodes(productName, carModel.slice(4));
    });
    if (!modelCodeIncludes) {
      // carModel = carModel.replace(/2022/g, '2023');
      var yearSelected = carModel.slice(0, 4);
      var yearToReplace = Number(yearSelected);
      var yearRegExp = new RegExp(yearSelected, 'g');
      // let yearToReplace = "/" + carModel.slice(0, 4) + "/g";
      carModel = carModel.replace(yearRegExp, yearToReplace);
      carModelNextyear = carModel.replace(yearRegExp, yearToReplace + 1);
    }
    var modelCode = products.find(function (product) {
      var productName = product.name;
      if (productName.startsWith(carModel.slice(0, 4)) || carModelNextyear.startsWith(carModel.slice(0, 4))) {
        if (_this3.compareModelCodes(productName, carModel)) {
          return true;
        }
        if (_this3.compareModelCodes(productName, carModelNextyear)) {
          return true;
        }
        return false;
      }
      if (_this3.compareModelCodes(productName, carModel.slice(4))) {
        return true;
      }
      if (_this3.compareModelCodes(productName, carModelNextyear.slice(4))) {
        return true;
      }
      return false;
    });
    if (modelCode !== undefined) {
      var radioValue = modelCode.code + "_" + modelCode.year;
      var selectedVehicle = {
        code: modelCode.code,
        year: modelCode.year
      };
      if (handleChangeEvent) {
        handleChangeEvent(position, [radioValue]);
      }
      if (actions) {
        actions.selectVehicle(selectedVehicle);
      }
      if (handleFieldBlur) {
        handleFieldBlur([radioValue], position, ['', '']);
      }
    }
  };
  _proto.renderCards = function renderCards(productTile, selectedLabel, selectedValue) {
    var _this4 = this;
    var _this$props4 = this.props,
      handleChangeEvent = _this$props4.handleChangeEvent,
      actions = _this$props4.actions,
      _this$props4$data = _this$props4.data,
      addPriceDisclaimer = _this$props4$data.addPriceDisclaimer,
      priceDisclaimerId = _this$props4$data.priceDisclaimerId,
      disclaimerData = _this$props4$data.disclaimerData;
    var currentHandleChangeEvent = handleChangeEvent || actions ? this.handleChangeEvent : null;
    if (productTile && productTile.length > 0) {
      return productTile.map(function (oneTile, index) {
        var _this4$props = _this4.props,
          theme = _this4$props.theme,
          isDuplicate = _this4$props.isDuplicate;
        // const decodedSelectedValue = getVehicleByGuid(selectedValue)
        return /*#__PURE__*/_react["default"].createElement(_homepageCarSelectorEntry["default"], {
          key: oneTile.code + "-" + index + (isDuplicate ? '-DUPLICATE' : ''),
          oneTile: oneTile,
          theme: theme,
          isDuplicate: isDuplicate,
          handleChangeEvent: currentHandleChangeEvent,
          selectedValue: selectedValue,
          selectedLabel: selectedLabel,
          addPriceDisclaimer: addPriceDisclaimer,
          priceDisclaimerId: priceDisclaimerId,
          disclaimerData: disclaimerData
        });
      });
    }
    return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
  };
  _proto.render = function render() {
    var _this$props5 = this.props,
      data = _this$props5.data,
      theme = _this$props5.theme,
      tabId = _this$props5.tabId,
      requiredMessage = _this$props5.requiredMessage,
      errorMessages = _this$props5.errorMessages,
      handleChangeEvent = _this$props5.handleChangeEvent,
      actions = _this$props5.actions;
    var _this$state = this.state,
      isDuplicate = _this$state.isDuplicate,
      hasDuplicates = _this$state.hasDuplicates,
      isMobile = _this$state.isMobile,
      selectedMobileIndex = _this$state.selectedMobileIndex;
    // Get the selected value from props or cookie (and update parent if cookie if used)
    var vehicleString = this.getVehicleString();

    // Compose data data object based on selected value
    var vehicleObject = this.getVehicleObjectFromString(vehicleString);
    var currentHandleChangeEvent = handleChangeEvent || actions ? this.handleChangeEvent : null;
    var productTile = data.productTile || [];
    var selectedLabel = data.selectedLabel || '';
    var selectedCardIndex = productTile.findIndex(function (vehicle) {
      return vehicle.code === vehicleObject.code && (vehicleObject.year === undefined || Number(vehicleObject.year) === Number(vehicle.year));
    });
    var valueToPass = vehicleObject.string;
    var currentError = '';

    // Above we add the duplicate flag if required (based on multi carousels duplication rules)
    if (hasDuplicates) {
      if ((selectedCardIndex === productTile.length - 1 || selectedCardIndex === productTile.length - 2) && !isDuplicate) {
        selectedCardIndex += productTile.length;
      } else if (isDuplicate && !(selectedCardIndex === productTile.length - 1 || selectedCardIndex === productTile.length - 2)) {
        selectedCardIndex += productTile.length;
        valueToPass += '-DUPLICATE';
      }
    }

    // Clear Errors upon any selection
    if (errorMessages !== undefined) {
      if (errorMessages.find(function (message) {
        return message !== '';
      }) !== undefined) {
        currentError = requiredMessage;
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].masterContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-1'] + " " + _homepageCarSelector["default"].componentTitle
    }, data.componentLabel && /*#__PURE__*/_react["default"].createElement(_carSelectorTitle["default"], {
      theme: theme,
      sectionTitle: data.componentLabel
    })), !isEmptyArray(productTile) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].carouselContainer,
      "data-selected-value": valueToPass
    }, isMobile ? /*#__PURE__*/_react["default"].createElement(_mobileCarousel["default"], {
      products: productTile,
      vehicleObject: vehicleObject,
      tabId: tabId,
      theme: theme,
      selectedLabel: selectedLabel,
      selectedMobileIndex: selectedMobileIndex,
      selectedCardValue: valueToPass,
      handleChangeEvent: currentHandleChangeEvent,
      addPriceDisclaimer: data.addPriceDisclaimer,
      priceDisclaimerId: data.priceDisclaimerId,
      disclaimerData: data.disclaimerData
    }) : /*#__PURE__*/_react["default"].createElement(_commonMultiCarousel.CommonMultiCarousel, {
      cards: this.renderCards(productTile, selectedLabel, vehicleObject.string),
      products: data.productTile,
      tabId: tabId,
      selectedCardIndex: selectedCardIndex,
      selectedCardValue: valueToPass,
      setDuplicates: this.setDuplicates
    })), currentError && /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].formWidth
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _homepageCarSelector["default"].errorMsg + " " + theme.smallType + " " + _homepageCarSelector["default"].showMsg,
      role: "alert"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _homepageCarSelector["default"].errorIcon,
      src: "data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 9.5h11L5.5 0 0 9.5zM6 8H5V7h1v1zm0-2H5V4h1v2z' fill='%23ED0000' fill-rule='nonzero'/%3E%3C/svg%3E",
      alt: "errorIcon"
    }), currentError)));
  };
  return HomepageCarSelector;
}(_react["default"].Component);
exports["default"] = HomepageCarSelector;
HomepageCarSelector.displayName = 'HomepageCarSelector';